import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchSaleYearlyStat(context, data = null) {
            if (!context.state.saleYearly.isNeedFetch) {
                return
            }

            if (data === null) {
                data = {year: null}
            }

            return pushModel(context, 'sale_yearlies/stat', data, 'updateSaleYearly')
        },
    },
    mutations: {
        updateSaleYearly(state, data) {
            state.saleYearly.models = data
            state.saleYearly.isNeedFetch = false
        },
    },
    state: {
        saleYearly: {
            models: [],
            isNeedFetch: true
        },
    },
    getters: {
        getSaleYearly(state) {
            return state.saleYearly.models
        },
    }
}
